import { isUndNullEmp } from '../../helpers/main';

export class TokenUser {
    constructor(
        _id = '',
        _register = '',
        _user = '',
        _exp = 0,
        _expDate = '',
        _iat = 0,
        _iatDate = '',
        _token = '',
    ) {
        this.id = _id;
        this.register = _register;
        this.user = _user;
        this.exp = _exp;
        this.expDate = _expDate;
        this.iat = _iat;
        this.iatDate = _iatDate;
        this.token = _token;
    }

    static getClassName = () => {
        return 'TokenUser - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    //Id: 0,
                    UserId: 10,
                    Token: 10,
                    Register: 10,
                    //Iat: 0
                    //Exp: 0,
                    IatDate: 10,
                    ExpDate: 10,
                },
                max: {
                    //Id: 0,
                    UserId: 450,
                    Token: 450,
                    Register: 30,
                    //Iat: 0
                    //Exp: 0,
                    IatDate: 30,
                    ExpDate: 30,
                }
            };
        } else {
            return {
                min: {
                    //id: 0,
                    userId: 10,
                    token: 10,
                    register: 10,
                    //iat: 0
                    //exp: 0,
                    iatDate: 10,
                    expDate: 10,
                },
                max: {
                    //id: 0,
                    userId: 450,
                    token: 450,
                    register: 30,
                    //iat: 0
                    //exp: 0,
                    iatDate: 30,
                    expDate: 30,
                }
            };
        }
    }

    static class = (obj = {}) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            return new TokenUser(
                obj.id,
                obj.register,
                obj.user,
                obj.exp,
                obj.expDate,
                obj.iat,
                obj.iatDate,
                obj.token,
            );
        } else {
            return new TokenUser();
        }
    }
}